export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'prazo_descricao',
    caption: 'Descrição'
  },
  {
    dataField: 'prazo_formula',
    caption: 'Fórmula'
  },
  {
    dataField: 'qtde_parc_prazo',
    caption: 'Qtde Parcelas'
  },
  {
    caption: 'Ações',
    cellTemplate: 'acaoCell',
    width: 100
  }
]
